import { settingsStore } from "./settings";
import { sessionStore } from "./session";
import { derived } from "svelte/store";
import get from "lodash/get";
import defaultsDeep from "lodash/defaultsDeep";

// This derived store is used so the copy can be instanteneously updated on the views
// This will be used for the editor and for i18n language selection

type Options = {
  basePath?: string,
  defaultReturnValue?: unknown
}

// Most of the times we will be fetching from "routes", so keeping "routes" as default
// For other base paths, we can pass it as second argument, or false to get from root
export const getCopy = derived([settingsStore, sessionStore],
  ([$settings, $session]) => (path: string, options?: Options) => {
    const { basePath, defaultReturnValue } = { basePath: "routes", defaultReturnValue: {}, ...options };
    const keyPath = basePath.length ? `${basePath}.${path}` : path;
    const i18nPath = $session.language === "en" ? keyPath : `i18n.${$session.language}.${keyPath}`;

    return defaultsDeep(
      get($settings, i18nPath, defaultReturnValue),
      get($settings, keyPath, defaultReturnValue)
    ) as unknown;
  }
);
